<template>
  <div class="fullText">
    <viewHeader></viewHeader>
    <div class="content">
      <el-card
        class="box-card"
        shadow="never"
        v-loading="loading"
        :element-loading-text="loadingText"
      >
        <el-row :gutter="30" class="fullTitle" slot="header">
          <el-col :span="14" class="title clearfix">
            <img src="../assets/img/icon7.png" alt="" class="L" />
            <span class="L">{{ detailData.title_en }}</span>
          </el-col>
          <el-col
            :span="5"
            class="YXYZ clearfix"
            v-if="detailData.impact_factor && detailData.impact_factor !== ''"
          >
            <img src="../assets/img/icon6.png" alt="" class="L" />
            <span class="L">影响因子：{{ detailData.impact_factor }}</span>
          </el-col>
          <el-col
            :span="4"
            class="RGBZ clearfix"
            v-if="detailData.has_manual_curation !== 0"
          >
            <img src="../assets/img/icon5.png" alt="" class="L" />
            <span class="L"
              >人工标注：{{ detailData.has_manual_curation }}</span
            >
          </el-col>
        </el-row>
        <el-row class="clearfix actionRow">
          <div class="tags">
            <articleTags :pubdate="detailData.pubdate_show" :language="detailData.language" :pubType="detailData.pub_type"></articleTags>
          </div>
          <p class="action clearfix">
            <a
              href="javascript:;"
              class="original L"
              @click="showOriginText(detailData.pmid, detailData.full_link)"
              >查看原文</a
            >
            <a href="javascript:;" class="translate L" @click="translateKey"
              >翻译</a
            >
            <a
              href="javascript:;"
              class="L"
              :class="detailData.is_collected ? 'collectionTrue' : 'collection'"
              @click="collection"
              >{{ detailData.is_collected ? "已收藏" : "收藏" }}</a
            >
            <a
              v-if="detailData.is_download && isVip == 2"
              href="javascript:;"
              class="L download"
              @click="pptDialog = true"
              >自动生成PPT</a
            >
            <a
              v-show="uploaded && isVip == 2"
              @click="handleSmartRead"
              href="javascript:;"
              class="L smartread"
            >SmartRead</a>
            <!-- <a href="javascript:;" class="share L">分享</a> -->
          </p>
        </el-row>
        <div class="textInfo">
          <el-row>
            <el-col :span="24"><span>PMID：</span>{{ detailData.pmid }}</el-col>
          </el-row>
          <el-row v-if="detailData.doi">
            <el-col :span="24"><span>DOI：</span>{{ detailData.doi }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="1.5"><span>期刊：</span></el-col>
            <el-col :span="20">{{ detailData.journal_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
              ><span>页码：</span>{{ detailData.pages }}</el-col
            >
          </el-row>
          <!-- <el-row>
            <el-col :span="24"
              ><span>发表时间：</span>{{ detailData.pubdate_show || "" }}</el-col
            >
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <span>作者：</span>
              <em v-for="(item, index) in detailData['author']" :key="index"
                >{{ item
                }}<i v-if="index + 1 < detailData['author'].length"> 、</i></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Diseases']
            "
          >
            <el-col :span="1.5"><span>疾病：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(disease, diseaseIndex) in detailData.keyword_categories[
                  'Diseases'
                ]"
                :key="diseaseIndex"
                >{{ disease[0] + "(" + disease[1] + ")"
                }}<i
                  v-if="
                    diseaseIndex + 1 <
                    detailData.keyword_categories['Diseases'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Drugs and Chemicals']
            "
          >
            <el-col :span="1.5"><span>药品：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(drug, drugIndex) in detailData.keyword_categories[
                  'Drugs and Chemicals'
                ]"
                :key="drugIndex"
                >{{ drug[0] + "(" + drug[1] + ")"
                }}<i
                  v-if="
                    drugIndex + 1 !==
                    detailData.keyword_categories['Drugs and Chemicals'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Geographic Locations']
            "
          >
            <el-col :span="24">
              <span>地理位置：</span>
              <em
                v-for="(location, locationIndex) in detailData
                  .keyword_categories['Geographic Locations']"
                :key="locationIndex"
                >{{ location[0] + "(" + location[1] + ")"
                }}<i
                  v-if="
                    locationIndex + 1 !==
                    detailData.keyword_categories['Geographic Locations'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Persons']
            "
          >
            <el-col :span="24">
              <span>人群：</span>
              <em
                v-for="(person, personIndex) in detailData.keyword_categories[
                  'Persons'
                ]"
                :key="personIndex"
                >{{ person[0] + "(" + person[1] + ")"
                }}<i
                  v-if="
                    personIndex + 1 !==
                    detailData.keyword_categories['Persons'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Oragnisms']
            "
          >
            <el-col :span="24">
              <span>生物种类：</span>
              <em
                v-for="(oragnisms, oragnismsIndex) in detailData
                  .keyword_categories['Oragnisms']"
                :key="oragnismsIndex"
                >{{ oragnisms[0] + "(" + oragnisms[1] + ")"
                }}<i
                  v-if="
                    oragnismsIndex + 1 !==
                    detailData.keyword_categories['Oragnisms'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories[
                'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
              ]
            "
          >
            <el-col :span="1.5"><span>实验技术与仪器：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(experiment, experimentIndex) in detailData
                  .keyword_categories[
                  'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
                ]"
                :key="experimentIndex"
                >{{ experiment[0] + "(" + experiment[1] + ")"
                }}<i
                  v-if="
                    experimentIndex + 1 !==
                    detailData.keyword_categories[
                      'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
                    ].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Biological Sciences']
            "
          >
            <el-col :span="1.5"><span>生物科学关键词：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(biological, biologicalIndex) in detailData
                  .keyword_categories['Biological Sciences']"
                :key="biologicalIndex"
                >{{ biological[0] + "(" + biological[1] + ")"
                }}<i
                  v-if="
                    biologicalIndex + 1 !==
                    detailData.keyword_categories['Biological Sciences'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Health Care']
            "
          >
            <el-col :span="1.5"><span>医疗研究关键词：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(health, healthIndex) in detailData.keyword_categories[
                  'Health Care'
                ]"
                :key="healthIndex"
                >{{ health[0] + "(" + health[1] + ")"
                }}<i
                  v-if="
                    healthIndex + 1 !==
                    detailData.keyword_categories['Health Care'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.interpr_unstruct &&
              detailData.interpr_unstruct.length === []
            "
          >
            <el-col :span="24" class="clearfix">
              <span class="L">文章解读：</span>
              <ul class="L">
                <li
                  v-for="(article, articleIndex) in detailData.interpr_unstruct"
                  :key="articleIndex"
                >
                  {{ index + 1 + "、" + article }}
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.interpr_struct &&
              detailData.interpr_struct.length === []
            "
          >
            <el-col :span="24">
              <span>结构化结论：</span>
              <table>
                <tr>
                  <th>主体类别</th>
                  <th>主体</th>
                  <th>特征</th>
                  <th>描述</th>
                  <th>定性描述</th>
                </tr>
                <col style="width: 15%" />
                <col style="width: 15%" />
                <col style="width: 15%" />
                <col style="width: 30%" />
                <col style="width: 25%" />
                <tbody>
                  <tr
                    v-for="(item, index) in detailData.interpr_struct"
                    :key="index"
                  >
                    <td v-for="(item1, index1) in item" :key="index1">
                      {{ item1 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[0] &&
              detailData.key_information[0][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究背景：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[0][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[1] &&
              detailData.key_information[1][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究目标：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[1][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[2] &&
              detailData.key_information[2][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究方法：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[2][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[3] &&
              detailData.key_information[3][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究结果：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[3][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[4] &&
              detailData.key_information[4][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究结论：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[4][1] }}</el-col>
          </el-row>
          <el-row v-if="detailData.important_message && detailData.important_message.length != 0 && isVip == 2">
            <el-col :span="24"><span>重点信息：</span></el-col>
            <el-col :span="24" style="margin-top: 10px">
              <p
                style="margin-top: 10px"
                v-for="(item, index) in detailData.important_message" :key="'重点信息' + index">
                {{ `● ${item}` }}
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"><span>文献摘要：</span></el-col>
            <el-col :span="24" style="margin-top: 10px">
              <p
                style="margin-top: 10px"
                v-for="(item, index) in detailData.abstract_en" :key="index">
                {{ item }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <!-- ppt下载选择框 -->
    <el-dialog
      title="PPT下载"
      :visible.sync="pptDialog"
      width="360px"
      top='30vh'
      custom-class='pptDialog'
      :close-on-click-modal='false'
      >
      <div class="pptDialogContent">
        <div class="item">
          <span class="label">语言</span>
          <div class="lanSelect">
            <div class="selectItem" :class="{lanBtn : selectPPTLan == 'en'}" @click="switchLan('en')">英文</div>
            <div class="selectItem" :class="{lanBtn : selectPPTLan == 'cn'}" @click="switchLan('cn')">中文</div>
          </div>
        </div>
        <div class="item">
          <span class="label">模版</span>
          <el-select class="select" v-model="selectTemplate" placeholder="请选择" size='small'>
            <el-option
              v-for="item in pptTemplate"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="templateView">
          <img class="preview" :src="templateMap[selectTemplate]" alt="">
        </div>
        <div class="templateView">
          <el-checkbox v-model="isDownLoadWord">同时下载文献全文中文翻译</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='small' :loading='pptLoading' @click="downLoadPPT(detailData.pmid)">{{downLoadText}}</el-button>
      </span>
    </el-dialog>
    <el-drawer
      size="530px"
      :visible.sync="drawer"
      :direction="direction">
      <template slot="title">
        <em>SmartRead</em>
        <span v-show="showPDFdetail" class="fullScreen" @click="showSmartReadDetail">
          <img src="../assets/img/fullScreen.png" alt=""/>
        </span>
      </template>
      <smartReadComponent
        ref="my-smartread"
        :smartReadHeight="smartReadHeight"
        :quesKeywordsList="quesKeywordsList"
        :messageHistoryList="messageHistoryList"
        @sendMessage="handleSendMessage"
        @messageHistory="handleGetMessageHistory"
        :hasMore="hasMore"
        :isFinishConversation="isFinishConversation">
      </smartReadComponent>
      <!-- <div class="send-message-box">
        <el-input v-model="messageText" placeholder="请输入您的问题"></el-input>
        <el-tooltip class="item" effect="dark" content="推荐问题" placement="top">
          <img src="../assets/img/icon_recommend_active.png" alt="">
        </el-tooltip>
        <el-button type="primary">Send</el-button>
      </div> -->
    </el-drawer>
  </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { md5 } from "md5js";
import dayjs from 'dayjs'
import viewHeader from "./viewHeader";
import articleTags from '../components/articleTags.vue'
import smartReadComponent from '../components/smartRead/smartRead.vue'
import { fullText, translateInfo, collection,downloadPPT,getRole,downloadWord,getUserVip,checkArticleData,generateQuesKeywords,articleConversationHistory } from "../service/getData";
import { webTrackerEvent,webTracker } from "../utils/tracker";
import { baseURL } from '../config/request'
import axios from 'axios'
export default {
  name: "fullText",
  PMID: "", // 文献pmid
  components: {
    viewHeader,
    articleTags,
    smartReadComponent
  },
  data() {
    return {
      loading: false,
      loadingText : '拼命加载中',
      detailData: [], // 文献详情
      PMID: "",
      isVip:undefined,
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154", // 秘钥
      clientId: "zeta", // 客户端id
      isTranslate: false, // 是否已经翻译了
      title: "",
      abstract_en: "",
      key_information: "",
      important_en: "",
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      pptDialog : false,// ppt下载弹框
      pptLoading : false,
      downLoadText : '确认下载',
      selectPPTLan : 'en',// 选择的语言
      selectTemplate : 'zeta_template_12',// 选择的模版
      pptTemplate:[
        {label:'红黄线条',value:'zeta_template_12'},
        {label:'清新薄荷',value:'zeta_template_11'},
        {label:'红色几何',value:'zeta_template_10'},
        {label:'宁静致远',value:'zeta_template_09'},
        {label:'国画山水',value:'zeta_template_07'},
        {label:'素雅几何',value:'zeta_template_08'},
        {label:'极简天蓝',value:'zeta_template_05'},
        {label:'粉蓝几何',value:'zeta_template_06'},
        {label:'高雅稳重黑',value:'zeta_template_01'},
        {label:'神秘高贵紫',value:'zeta_template_02'},
        {label:'清新自然黄',value:'zeta_template_03'},
        {label:'炫彩夺目粉',value:'zeta_template_04'}
      ],
      templateMap:{
        'zeta_template_01' : require('../assets/img/zeta_template_01.png'),
        'zeta_template_02' : require('../assets/img/zeta_template_02.png'),
        'zeta_template_03' : require('../assets/img/zeta_template_03.png'),
        'zeta_template_04' : require('../assets/img/zeta_template_04.png'),
        'zeta_template_05' : require('../assets/img/zeta_template_05.png'),
        'zeta_template_06' : require('../assets/img/zeta_template_06.png'),
        'zeta_template_07' : require('../assets/img/zeta_template_07.png'),
        'zeta_template_08' : require('../assets/img/zeta_template_08.png'),
        'zeta_template_09' : require('../assets/img/zeta_template_09.png'),
        'zeta_template_10' : require('../assets/img/zeta_template_10.png'),
        'zeta_template_11' : require('../assets/img/zeta_template_11.png'),
        'zeta_template_12' : require('../assets/img/zeta_template_12.png'),
      },
      isDownLoadWord:false,// 是否下载word
      drawer: false,
      direction: 'rtl',
      messageText: '',
      smartReadHeight: 'calc(100vh - 110px)',
      uploaded: false,
      quesKeywordsList: {},
      messageHistory: [],
      messageHistoryList: [], // 聊天记录
      limit: 10,
      offset: 0, // 记录的偏移量 如：offset就是0，然后limit=10，就是取10条。然后再往上翻，就是offset=10, limit仍然是10
      last_message_id: '', // 上次返回的第一条消息的id，如果是第⼀一次请求，则不不传。
      hasMore: true, // 是否有更多记录。
      hasMore: true, // 是否有更多记录
      pmcid: '', // 获取文献pdf时需要的id
      showPDFdetail: true, // 是否显示pdf全文
      isFinishConversation: true
    };
  },
  methods: {
    /**
     * 获取文献pdf
    */
    getArticlePDF() {
      if (this.pmcid == '') {
        this.showPDFdetail = false;
        return
      };
      axios.get('/pmc/utils/oa/oa.fcgi?id='+this.pmcid+'&format=pdf',{}).then(res => {
        if (res.data.indexOf('link') != -1) {
          this.showPDFdetail = true;
        } else {
          this.showPDFdetail = false; 
        }
      })
    },
    /**
     * 开始聊天
    */
    handleFormatData() {
      let dateJson = {};
      this.messageHistoryList = [];
      this.messageHistory.forEach(item => {
        let date = item.timestamp.split(' ')[0];
        if (!dateJson[date]) {
          dateJson[date] = [];
        }
      });
      if (this.messageHistoryList.length == 0) {
        this.messageHistoryList.unshift(dateJson);
      } else {
        // 否则，遍历要添加的对象
        Object.keys(dateJson).forEach(key => {
          this.messageHistoryList.filter(item => {
            if (!item[key]) {
              item[key] = []
            }
          })
        })
      }

      this.messageHistory.forEach(item => {
        let date = item.timestamp.split(' ')[0];
        this.messageHistoryList.filter(item2 => {
          if (item2[date]) {
            item2[date].push(item)
          }
        })
      })
    },
    async handleSendMessage(data) {
      let date = this.handleFormatDate();
      this.messageHistory.push(
        {
          role: 'user',
          content: data,
          loading: false,
          timestamp: date
        },
        {
          role: 'assistant',
          content: '',
          loading: true,
          timestamp: date
        }
      )
      this.handleFormatData();

      this.$nextTick(() => {
        this.$refs['my-smartread'].$el.scrollTop = this.$refs['my-smartread'].$el.scrollHeight;
      })

      let params = {
        paper_id: this.PMID, // pmid
        target: 'full_text', // "full_text" - 基于整个论⽂聊；"section" - 基于某个section聊，目前只能传full_text
        text: data,
        stream: true // true - 使⽤ stream 模式; false - 使⽤⾮ stream 模式。
      }

      // 建立 FETCH-SSE 连接
      let controller = new AbortController();
      let content = '';
      fetchEventSource(baseURL+'/conversation', 
        {
          method: 'POST', 
          body: JSON.stringify(params),
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json', 
            'Accept': '*/*',
            'Authorization': localStorage.getItem('PUBMEDSEARCHTOKEN')
          },
          onopen: () => {
            console.log('连接成功');
          },
          onclose: () => {
            console.log('连接关闭');
          },
          onmessage: (msg) => {
            this.$nextTick(() => {
              this.$refs['my-smartread'].sendLoading = false;
            })
            let current2= [];
            this.messageHistoryList.filter(item => {
              current2 = item[date]
            });
            let index2 = current2.length-1;
            let current = this.messageHistory[this.messageHistory.length - 1];
            let index = this.messageHistory.length-1;

            if (!msg) return;
            const dataText = JSON.parse(msg.data);
            this.isFinishConversation = false; // 是否结束对话
            // 结束
            if (dataText.type == 'finished_answer') { 
              this.$set(current, 'loading', false);
              this.$set(current2[index2], 'loading', false);
              this.messageHistoryList.filter(item => {
                if (item[date]) {
                  item[date] = current2
                }
              });
              this.$set(this.messageHistory, index, current);
              closeSSE();
              return
            }

            // 持续输出
            if (dataText.type == 'new_token') {
              content += dataText.text;
              this.$set(current, 'content', content);
              this.$set(current, 'loading', false);
              this.$set(current2[index2], 'content', content);
              this.$set(current2[index2], 'loading', false);
              this.messageHistoryList.filter(item => {
                if (item[date]) {
                  item[date] = current2
                }
              });
              this.$set(this.messageHistory, index, current);
              this.$nextTick(() => {
                this.$refs['my-smartread'].$el.scrollTop = this.$refs['my-smartread'].$el.scrollHeight;
              })
            }
          },
          onerror: (e) => {
            console.log(e)
          }
        }
      );

      // 断开 FETCH-SSE 连接
      const closeSSE = () => {
        if (controller) {
          controller.abort()
          controller = undefined
          console.log('FETCH 连接关闭');
          this.isFinishConversation = true
        }
      }
    },
    /**
     * 获取论文聊天历史
    */
    async handleGetMessageHistory(initial = true) {
      this.$nextTick(() => {
        this.$refs['my-smartread'].messageLoading = true;
      })
      let params = {
        paper_id: this.PMID,
        target: 'full_text', // "full_text" - 基于整个论⽂聊；"section" - 基于某个section聊，目前只有full_text
        limit: this.limit, // 返回的最⼤记录数
        // offset: this.offset // 返回的记录偏移量
      }
      if (this.last_message_id != '') {
        params.last_message_id = this.last_message_id
      }

      let res = await articleConversationHistory(params)
      this.$nextTick(() => {
        this.$refs['my-smartread'].messageLoading = false;
      })
      if (res.data.status == 0) {
        let { history } = res.data;
        if (history.length > 0) {
          this.hasMore = true;
          // this.offset += 10;
          this.last_message_id = history[0].message_id;
          this.messageHistory = history.concat(this.messageHistory);
          // 合并后避免重复，去除message_id为空的内容
          for (let i = 0; i < this.messageHistory.length; i++) {
            if (!this.messageHistory[i]['message_id']) {
              this.messageHistory.splice(i, this.messageHistory[i]);
              i--
            }
          }
          this.handleFormatData();

          if (initial) {
            this.$nextTick(() => {
              this.$refs['my-smartread'].$el.scrollTop = this.$refs['my-smartread'].$el.scrollHeight;
            })
          }
        } else {
          this.hasMore = false
        }
      } else {
        this.messageHistoryList = []
      }
    },
    /**
     * 转日期
    */
    handleFormatDate() {
      let timestamp = new Date();
      let year = timestamp.getFullYear();
      let month = (timestamp.getMonth() + 1) < 10 ?  '0'+(timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
      let date = timestamp.getDate() < 10 ? '0'+timestamp.getDate() : timestamp.getDate();
      return year+'-'+month+'-'+date
    },
    handleSmartRead() {
      this.drawer = true;
      this.$nextTick(() => {
        this.handleGenerateQuesKeywords();
        this.handleGetMessageHistory();
      })
    },
    /**
     * 根据论文生成若干问题和关键词
    */
    async handleGenerateQuesKeywords() {
      if (this.quesKeywordsList['questions'] && this.quesKeywordsList['keywords']) {
        return
      }
      this.$nextTick(() => {
        this.$refs['my-smartread'].keywordsLoading = true;
      })
      let params = {
        paper_id: this.PMID, // pmid
        question_amount: 3, // 需要⽣成的问题数，暂定最多10个
        keyword_amount: 5, // 需要⽣成的关键词数，暂定最多10个
        type: 'abstract', // ⽣成类型："abstract" - 根据论⽂摘要⽣成；"section" - 根据section摘要⽣成，目前只能传abstract
      }
      let res = await generateQuesKeywords(params)
      this.$nextTick(() => {
        this.$refs['my-smartread'].keywordsLoading = false;
      })
      if (res.data.status == 0) {
        let { keywords, questions } = res.data;
        this.quesKeywordsList['questions'] = questions;
        this.quesKeywordsList['keywords'] = keywords;
      }
    },
    /**
     * 检查论文是否已上传
    */
    async handleCheckArticleData() {
      let params = {
        pmid: this.PMID
      }
      let res = await checkArticleData(params)
      if (res.data.status == 0) {
        this.uploaded = res.data.uploaded
      }
    },
    showSmartReadDetail() {
      const { href } = this.$router.resolve({
        name: "conversation",
        path: "/conversation",
        query: {
          pmid: this.PMID,
          pmcid: this.pmcid
        },
      });
      window.open(href);
    },
    /**
     * 选择语言
     */
    switchLan(value){
      this.selectPPTLan = value;
    },
    /**
     * 下载ppt
     * @param pmid pmid
     */
    downLoadPPT(pmid){
      this.pptLoading = true;
      this.downLoadText = '正在下载'
      let params = {
        pmid : pmid,
        model : this.selectTemplate + '.pptx',
        language : this.selectPPTLan
      }
      let token = localStorage.getItem('PUBMEDSEARCHTOKEN')
      let url =  `${baseURL}${downloadPPT}`
      axios.get(`${url}`,{
        params:params,
        responseType:'blob',
        headers:{
          Authorization : token
        }
      }).then(res => {
        if(res.headers['content-type'] == 'application/json') {
          this.$alert('目前PPT转换服务繁忙，请稍后重试', '提示', {
            confirmButtonText: '确定',
            type:'warning',
            callback: action => {
              this.pptDialog = false;
            }
          });
          return;
        }
        const fileName = decodeURI(res.headers.filename);
        const blob = new Blob([res.data], { type: 'application/octet-stream' });
        this._saveBlob(blob,fileName);
        

        // log appen by chenbin 2021-06-24
        let Logger = webTrackerEvent();
        Logger.push('action','pptDownload');
        Logger.push('token', token);
        Logger.push('pmid', pmid);
        Logger.push('search_type', this.selectTemplate + '.pptx');
        Logger.push('language', this.selectPPTLan);
        Logger.push("openid", this.openid);
        Logger.push("page_url", window.location.href);
        Logger.logger()

        // 下载word
        // append by chenbin 2021-11-15

        if(this.isDownLoadWord) {
          setTimeout(() => { // 2023-4-17，chenbin - ios下载文件会有弹框提示，会中断下面的代码执行，因此推入宏任务中执行
            let model = 'zeta_word_template_0.docx';
            const wordParams = {
              pmid : pmid,
              model : model,
            }
            const wordURL = `${baseURL}${downloadWord}`;
            axios.get(`${wordURL}`,{
              params:wordParams,
              responseType:'blob',
              headers:{
                Authorization : token
              }
            }).then(wordRes => {
  
              const wordName = decodeURI(wordRes.headers.filename);
              const wordBlob = new Blob([wordRes.data], { type: 'application/octet-stream' });
              this._saveBlob(wordBlob,wordName);
    
              let Logger = webTrackerEvent();
              Logger.push('action','wordDownload');
              Logger.push('token', token);
              Logger.push('pmid', pmid);
              Logger.push('search_type', model);
              Logger.push("openid", this.openid);
              Logger.push("page_url", window.location.href);
              Logger.logger()
            }).catch(err => {
              console.log(err);
            })
            
          }, 100);
        }
        
        this.pptDialog = false;

      })
      .catch(error => {
        this.$alert(`目前PPT转换服务繁忙，请稍后重试`, '提示', {
          confirmButtonText: '确定',
          type:'warning',
          callback: action => {
            this.pptDialog = false;
          }
        });
        let Logger = webTracker();
        Logger.push('userHeadImg', window.localStorage.getItem('PUMMEDSEARCHHEADIMG'));
        Logger.push('userName', window.localStorage.getItem('PUMMEDSEARCHUSERNAME'));
        Logger.push('response_error_code', error.response.status);
        Logger.push('response_error_config', JSON.stringify(error.response.config));
        Logger.logger()
        return;
      })
      .finally(() => {
        this.pptLoading = false;
        this.downLoadText = '确认下载';

      });

    },
    /**
     * 保存文件流
     */
    _saveBlob(blob,fileName){

      if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
          // 兼容IE/Edge
        window.navigator.msSaveOrOpenBlob(blob,fileName)
      } else {
        let url = URL.createObjectURL(blob);
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(elink);
      }

    },
    async getFullText() {
      this.loading = true;
      const res = await fullText(this.PMID);
      this.loading = false;
      if (res.data.status === 0) {
        // if (res.data.data["pubdate_show"]) {
        //   const date = res.data.data["pubdate_show"].substring(0, 10);
        //   res.data.data["pubdate_show"] = date;
        // }
        this.title = res.data.data["title_en"];
        this.abstract_en = res.data.data["abstract_en"];
        this.key_information = res.data.data["key_information"];
        this.important_en = res.data.data["important_message"];
        this.detailData = res.data.data;
        this.pmcid = res.data.data["pmcid"];
        this.getArticlePDF();
      } else {
        this.loading = false;
      }
    },
    // 翻译重点信息
    async translateKey() {
      this.loading = true;
      let Logger = webTrackerEvent();
      if (this.isTranslate) {
        this.loading = false;
        this.detailData["title_en"] = this.title;
        this.detailData["key_information"] = this.key_information;
        this.detailData["abstract_en"] = this.abstract_en;
        this.detailData["important_message"] = this.important_en;
        this.isTranslate = false;

        Logger.push("page_url", window.location.href);
        Logger.push("language", "en_key");
        Logger.push("action", "translate");
        Logger.push("pmid", this.PMID);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        return;
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${this.PMID}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(this.PMID),
        types: "cn_key",
        token: token,
      };
      const res = await translateInfo(params);

      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", "cn_key");
      Logger.push("pmid", this.PMID);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        this.detailData.title_en = res.data.data.title;
        this.detailData.key_information = res.data.data.sentence;
        this.detailData.important_message = res.data.data.important_message;
        this.translateFullText();
      }
    },
    // 翻译摘要（全文）
    async translateFullText() {
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${this.PMID}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(this.PMID),
        types: "cn_full",
        token: token,
      };
      const res = await translateInfo(params);
      if (res.data.status == 0) {
        this.detailData.abstract_en = res.data.data.sentence;
        this.loading = false;
        this.isTranslate = true;
      }
    },
    // 收藏还是取消收藏
    async collection() {
      const params = { pmid: this.detailData.pmid };
      if (!this.detailData.is_collected) {
        const res = await collection("POST", params);
        if (res.data.status === 0) {
          this.detailData.is_collected = true;
        } else {
          this.$message({
            message: "收藏失败，请重试",
            type: "error",
          });
        }
      } else {
        const res = await collection("DELETE", params);
        if (res.data.status === 0) {
          this.detailData.is_collected = false;
        } else {
          this.$message({
            message: "取消失败，请重试",
            type: "error",
          });
        }
      }
    },
    // 查看原文
    showOriginText(pmid, link) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "originalText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      window.open(link);
    },
    // 获取用户角色
    async getUserRole() {
      const res = await getRole();
      if (res && res.data.status === 0) {
        // this.isVip = Number(res.data.data["is_vip"]);
        // window.localStorage.setItem("ISVIP", res.data.data["is_vip"]);
        window.localStorage.setItem("ISADMIN", res.data.data["is_admin"]);
        window.localStorage.setItem("ISEDITOR", res.data.data["is_editor"]);
      }
    },
    /**
     * 获取个人vip等级
     */
    async handleGetVip(){
      let res = await getUserVip();
      let {status,data} = res.data;
      if(status == 0) {
        let { vip2 } = data;
        let isVip = 1;// 默认1，最低级
        if(vip2) {
          let ifBefore = dayjs().isBefore(dayjs(vip2).add(1,'day'),'day');
          if(ifBefore) {
            isVip = 2;
          }
        }
        this.isVip  = isVip;
        window.localStorage.setItem("ISVIP", isVip);
      }
    },
  },
  created() {
    this.PMID = this.$route.query.pmid;
    let isVip = window.localStorage.getItem('ISVIP');
    if(isVip) {
      this.isVip = Number(isVip);
    } else {
      this.getUserRole();
      this.handleGetVip();
    }
    this.getFullText();
    this.handleCheckArticleData();
  },
};
</script>

<style scoped>
.content >>> .el-loading-mask .el-loading-spinner {
  top: 20% !important;

}
.fullText {
  background: #f9f9f9;
  padding-bottom: 50px;
}
.fullText .content .fullTitle {
  font-size: 16px;
  color: #4083d4;
}
.fullText .content {
  width: 1080px;
  margin: 0 auto;
}
.fullText .content .title span {
  margin-left: 18px;
  font-size: 16px;
  font-weight: bold;
  line-height: 34px;
  width: 90%;
}
.fullText .content .YXYZ span {
  line-height: 34px;
  margin-left: 10px;
  color: #333;
  font-size: 14px;
}
.fullText .content .RGBZ span {
  line-height: 34px;
  margin-left: 10px;
  color: #333;
  font-size: 14px;
}
.fullText .content .YXYZ img {
  width: 26px;
  height: 26px;
  margin-top: 5px;
}
.fullText .content .RGBZ img {
  width: 22px;
  height: 26px;
  margin-top: 5px;
}
.fullText .content .actionRow {
  width: 900px;
  margin: 0 auto;
}
.fullText .content .actionRow .tags {
  margin-top: 8px;
}
.fullText .content p.action {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.fullText .content p.action a {
  font-size: 14px;
  color: #4183D4;
  padding-left: 24px;
  margin-left: 20px;
  height: 34px;
  border: 1px solid #4183D4;
  display: block;
  border-radius: 20px;
  line-height: 34px;
  text-align: center;
}
.fullText .content p.action a.original {
  width: 84px;
  background: url("../assets/img/icon8-1.png") no-repeat 10px center;
}
.fullText .content p.action a.translate {
  width: 66px;
  background: url("../assets/img/icon1-1.png") no-repeat 14px center;
}
.fullText .content p.action a.collection {
  width: 66px;
  background: url("../assets/img/icon3-1.png") no-repeat 10px center;
}
.fullText .content p.action a.collectionTrue {
  width: 66px;
  background: url("../assets/img/icon3_01.png") no-repeat 10px center;
}
.fullText .content p.action a.share {
  width: 52px;
  background: url("../assets/img/icon4.png") no-repeat 10px center;
}
.fullText .content p.action a.download {
  width: 100px;
  background: url("../assets/img/downLoad.png") no-repeat 10px center;
}
.fullText .content p.action a.smartread {
  width: 100px;
  background: url("../assets/img/chatbot.png") no-repeat 10px center;
  background-size: 20px 20px;
}
.fullText .content div.textInfo {
  width: 900px;
  margin: 0 auto;
  margin-top: 30px;
}
.fullText .content div.textInfo .el-row {
  border-bottom: 1px dashed #ccc;
  padding: 15px 0;
  font-size: 14px;
  color: #333;
}
.fullText .content div.textInfo .el-row span {
  color: #387ed2;
  font-size: 16px;
}
.fullText .content div.textInfo .el-row table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-top: 20px;
}
.fullText .content div.textInfo .el-row table tr th {
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 5px;
}
.fullText .content div.textInfo .el-row table tr td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: center;
}
.fullText >>> .pptDialog {
  border-radius: 12px;
}
.fullText .pptDialogContent .item{
  display: flex;
  align-items: center;
}
.fullText .pptDialogContent .item:nth-child(1) {
  margin-bottom: 20px;
}
.fullText .pptDialogContent .item:nth-child(2) {
  margin-bottom: 12px;
}
.fullText .pptDialogContent .item .label {
  margin: 0 10px
}
.fullText .pptDialogContent .item .lanSelect {
  width: 240px;
  display: flex;
  justify-content: space-between;
}
.fullText .pptDialogContent .item .lanSelect .selectItem  {
  width: 115px;
  height: 30px;
  border: 1px solid #E6E6E6;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  border-radius: 4px;
  cursor: pointer;
}
.fullText .pptDialogContent .item .lanSelect .selectItem.lanBtn {
  color: #fff;
  background: #409EFF;
  border-color: #409EFF;
}
.fullText .pptDialogContent .item .select {
  width: 240px;
}
.fullText .pptDialogContent .templateView {
  padding-left: 47px;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.fullText .pptDialogContent .templateView .preview {
  width: 238px;
  border: 1px solid #eee;
}
</style>
<style scoped lang="less">
  /deep/.el-drawer{
    background-color: #F7F7F8 !important;
    header {
      margin-bottom: 0;
    }
    header >:first-child{
      flex: none;
      font-size: 16px;
      color: #191D23;
      font-weight: bold;
    }
    .fullScreen{
      margin-left: 16px;
      display: flex;
      align-items: center;
    }
    .el-drawer__close-btn{
      flex: 1;
      text-align: right;
    }
    img{
      width: 24px;
      cursor: pointer;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/fullText.vue